// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a578ad89","431":"d7ffbdbd","453":"c2bd2666","667":"c537cb55","977":"38157c35"}[chunkId] + ".chunk.js";
};